import isFeatureEnabledLib from '@ahmdigital/logic/lib/utils/is-feature-enabled';

import config from '../../config';

// @ts-expect-error: ahm logic needs to support generic for typeof config
const isFeatureEnabled = (feature: string) => isFeatureEnabledLib(config, feature);

export default isFeatureEnabled;
